import React from 'react';

const LoginFooter: React.FC = () => {
  return (
    <div
      style={{
        position: 'absolute',
        left: '-9999px',
        top: '-9999px',
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        width: 0,
        overflow: 'hidden',
      }}
    >
      {/* Informações da empresa para verificação do Facebook Meta Developer */}
      <div>
        <strong>E.R. 2 GESTAO EM TELECOMUNICACOES LTDA</strong>
      </div>
      <div>
        CNPJ: 61.286.322/0001-33
      </div>
      <div>
        Razão Social: E.R. 2 GESTAO EM TELECOMUNICACOES LTDA
      </div>
      <div>
        Nome Fantasia: Gettel Automação
      </div>
    </div>
  );
};

export default LoginFooter;
